import { ProjectHTMLRecord } from './project.types';

/**
 * AJAX HTML record store for the project section. Project pages are loaded
 * in the background by the app-level loaders and pushed in via
 * ProjectController.setHTML; if the user reaches a project before its HTML
 * has arrived the URL is flagged as queued and injected on arrival. Note:
 * this section does no fetching of its own.
 */
export class ProjectLoading {
	private _html: Array<ProjectHTMLRecord> = [];
	private _queSetProjectHTML: boolean = false;
	private _activeHTMLURL: string;

	/** Is the page waiting for this URL's HTML to arrive */
	public get queued(): boolean {
		return this._queSetProjectHTML;
	}

	public set queued(value: boolean) {
		this._queSetProjectHTML = value;
	}

	/** URL of the project HTML currently requested / injected */
	public get activeURL(): string {
		return this._activeHTMLURL;
	}

	public set activeURL(url: string) {
		this._activeHTMLURL = url;
	}

	/** Save a project's HTML to record */
	public store(url: string, html: string): void {
		this._html.push({ url: url, html: html });
	}

	/** Get HTML for subsection (tolerates trailing-slash mismatches) */
	public getHTML(url: string): string {
		let html: string = null;

		this._html.forEach((record: ProjectHTMLRecord) => {
			if (record.url === url || record.url === url + '/' || record.url + '/' == url) {
				html = record.html;
			}
		});

		return html;
	}
}
